import Amplify from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';
import { Hub } from '@aws-amplify/core';

import { actionTypes } from './constants';
import history from './history';

export default class AmplifyBridge {
  constructor(store) {
    this.store = store;

    this.onHubCapsule = this.onHubCapsule.bind(this);
    Hub.listen('auth', this, 'AmplifyBridge'); // Add this component as a listener of auth events.

    this.checkUser(); // first check
  }

  onHubCapsule(capsule) {
    this.checkUser(); // triggered every time user sign in / out
  }

  checkUser() {
    Auth.currentAuthenticatedUser()
      .then(user => {
        this.store.dispatch({
            type: actionTypes.SWITCH_USER,
            CognitoUser: user
        });
        this.loadProfile(user);
      })
      .catch(err => {
        console.error(err);
        this.store.dispatch({
            type: actionTypes.SWITCH_USER,
            CognitoUser: null
        });
        this.store.dispatch({
            type: actionTypes.DELETE_PROFILE,
        });
        if(history.location.pathname !== '/' && history.location.pathname !== '/login'){
            console.log(window.location.pathname);
            history.push(`/`)
        }
      });
  }

  loadProfile(user) {
    Auth.userAttributes(user)
    .then(data => {
        const profile = data.map(d=>({[d.Name]: d.Value})).reduce((a, v)=>({...a, ...v}));
        this.store.dispatch({
            type: actionTypes.UPDATE_PROFILE,
            profile: profile
        });
        this.store.dispatch({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'success',
            text: `Successfully signed in as ${profile.email}.`
          }
        });
    })
    .catch(err => {
        console.error(err);
        this.store.dispatch({
            type: actionTypes.DELETE_PROFILE
        })
        if(history.location.pathname !== '/' && history.location.pathname !== '/login'){
            history.push(`/`)
        }   
    });
  }
}
